import _taggedTemplateLiteral from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
import styled, { createGlobalStyle } from 'styled-components';
import { Box } from '@spa/shared/components/Modal/styles';
import { tabletRange } from '@spa/shared/theme';
import { mediaMin } from '@spa/shared/theme';
export var ModalGlobalStyle = /*#__PURE__*/createGlobalStyle([".wishlist{", "{display:flex;flex-direction:column;overflow:hidden;", " ", "}}"], Box, tabletRange.ipad()(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        width: 55%;\n      "]))), mediaMin.mediumBreakpoint(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        width: 100vw;\n        height: 100vh;\n        max-width: 100vw;\n        max-height: 100vh;\n        overflow-y: auto;\n      "]))));
export var ContentWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-m8y9n7-0"
})(["display:flex;flex-direction:column;& > p{font-family:IntervalNextBook;font-size:", ";line-height:1.31;color:", ";", ";}& > svg{position:absolute;bottom:-", ";right:", ";width:135px;", ";}", ";"], function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.typography.greyPrimary;
}, function (props) {
  return props.theme.smallBreakpoint(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      margin-top: ", ";\n    "])), function (props) {
    return props.theme.space(4);
  });
}, function (props) {
  return props.theme.space(7);
}, function (props) {
  return props.theme.space(17);
}, function (props) {
  return props.theme.smallBreakpoint(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      position: initial;\n      flex-shrink: 0;\n      margin-right: ", ";\n    "])), function (props) {
    return props.theme.space(4);
  });
}, mediaMin.smallBreakpoint(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    align-items: center;\n  "]))));
export var ActionsWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-m8y9n7-1"
})(["display:flex;width:50%;margin-top:", ";", ";& > button{width:50%;margin:0;&:first-child{margin-right:", ";}}"], function (props) {
  return props.theme.space(15);
}, function (props) {
  return props.theme.smallBreakpoint(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    width: 100%;\n  "])));
}, function (props) {
  return props.theme.space(4);
});